'use strict';

const _=require('pulsar-utils/dist-es6/_');
const BaseControllerBackedDirective=require('../../../../dist-es6/client/angularCommon/baseControllerBackedDirective');
const ScheduleGraphDirectiveController=require('../../../../dist-es6/client/directives/scheduleGraphDirective/scheduleGraphDirective').DirectiveController;
const fpe=require('pulsar-dashboard-core/dist-es6/extensions/fatiguePointExtensions');
const TimeInterval=require('pulsar-utils/dist-es6/timeInterval');
const CalendarRange=require('pulsar-utils/dist-es6/time/calendarRange');let

TimelineGraphDirective=class TimelineGraphDirective extends BaseControllerBackedDirective{
get templateUrl(){
return'/templates/directives/timelineGraphDirective/timelineGraphTemplate';
}

get objectBindings(){
return[
'interval',
'duties',
'trips',
'flights',
'sleep',
'sleepPromotingIntervals',
'timezone',
'fatigue',
'incidents',
'assessments',
'now',
'timeOfLastScheduleUpdate',
'invalidDataWarning',
'predictedWorkday',
'pastShifts',
'forecastDutyInterval',
'fatigueThreshold',
'fatigueThresholds',
'dutyLabelFormatter',
'tripLabelFormatter',
'flightLabelFormatter',
'sleepLabelFormatter',
'sleepPromotingLabelFormatter'];

}

get textBindings(){
return[
'useReportStyle'];

}

get controller(){
return TimelineGraphDirectiveController;
}};let


TimelineGraphDirectiveController=class TimelineGraphDirectiveController extends ScheduleGraphDirectiveController{
constructor(fatigueMeterTypeContentProviderService){
super(fatigueMeterTypeContentProviderService);

this.axisLabelMargins={
top:20,
right:0,
bottom:0,
left:this.useReportStyle?
56:
82};


this._dailyThresholds=this._getDailyThresholds();

if(fatigueMeterTypeContentProviderService.alertsSource!=='assessments'){
this._alertRanges=this._getAlertRangesFromDailyThresholds(this._dailyThresholds,this.duties.concat(this.forecastDutyInterval?[this.forecastDutyInterval]:[]));
this._tripAlertRanges=this._getAlertRangesFromDailyThresholds(this._dailyThresholds,this.trips.concat(this.flights));
}

this.alertingForecastedDutyIntervals=_.exists(this.forecastDutyInterval)?
TimeInterval.compress(_.compact(this._alertRanges.At.concat(this._alertRanges.Above).map(i=>this.forecastDutyInterval.intersection(i)))):
[];

this.tripRowHeight=this.useReportStyle?30:60;
this.tripTopY=this.useReportStyle?4:0;
this.tripIntervalVerticalMargin=this.useReportStyle?0:4;
this.sleepAndDutyVerticalMargin=this.useReportStyle?5:0;
this.overThresholdStrokeWidth=2.5;
this.underThresholdStrokeWidth=2.5;
this.sleepAndDutyTopMargin=this.useReportStyle?this.tripRowHeight+this.sleepAndDutyVerticalMargin:this.tripRowHeight;


const bottomOfSleepAndDuties=235;
const sleepPromotingHeight=this.useReportStyle?7:12;
this.sleepPromotingHeight=this.useReportStyle?bottomOfSleepAndDuties:sleepPromotingHeight;
this.sleepPromotingTopY=this.useReportStyle?bottomOfSleepAndDuties-sleepPromotingHeight:void 0;
}

_getDailyThresholds(){
const range=CalendarRange.fromExpandedTimeInterval(this.interval,this.timezone);
const daysInGraph=range.asDailyTimeIntervals({timezone:this.timezone,abut:!0});

if(this.fatigueThresholds.length!==daysInGraph.length){
throw new Error('day counts do not match, what\'s up with that?');
}

return daysInGraph.map((dayInterval,i)=>({
dayInterval,
effectiveThreshold:this.fatigueThresholds[i]}));

}

_getAlertRangesFromDailyThresholds(dailyThresholds,intervals){
const alertRanges={
At:[],
Above:[],
Below:[],
NotApplicable:[]};


for(const _ref of dailyThresholds){const{dayInterval,effectiveThreshold}=_ref;
const{At,Above,Below,NotApplicable}=fpe(this.fatigue).getAlertRangesOverlapping(effectiveThreshold,intervals.filter(i=>dayInterval.intersects(i)),dayInterval);
_.pushMany(alertRanges.At,At);
_.pushMany(alertRanges.Above,Above);
_.pushMany(alertRanges.Below,Below);
_.pushMany(alertRanges.NotApplicable,NotApplicable);
}

return{
At:TimeInterval.compress(alertRanges.At),
Above:TimeInterval.compress(alertRanges.Above),
Below:TimeInterval.compress(alertRanges.Below),
NotApplicable:TimeInterval.compress(alertRanges.NotApplicable)};

}};


module.exports=TimelineGraphDirective;
//# sourceMappingURL=timelineGraphDirective.js.map
